import { RESET_STATE } from 'store/global/actions';

import { LEAD_MATCH_SCHEMA_ACTION_TYPE } from '../actions';

const initialState = {};

const leadMatchSchemaReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LEAD_MATCH_SCHEMA_ACTION_TYPE.GET_SCHEMA:
      return payload || state;

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default leadMatchSchemaReducer;
